import AuthCheck from "./AuthCheck";
import RenderAuthCheck from "./RenderAuthCheck";

export default RenderAuthCheck(AuthCheck);  // TODO正式业务需要调整，只做演示
